// extracted by mini-css-extract-plugin
export default {"overlayFadeIn":"Cyclelist_overlayFadeIn__jIwW5","fadeIn":"Cyclelist_fadeIn__pG-kY","card":"Cyclelist_card__1beno"};